import { render, staticRenderFns } from "./CurrencyBar.vue?vue&type=template&id=11479818&scoped=true"
import script from "./CurrencyBar.vue?vue&type=script&lang=js"
export * from "./CurrencyBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11479818",
  null
  
)

export default component.exports